import React, { useEffect, useState, useCallback } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Box,
  Text,
  SimpleGrid,
  FormControl,
  FormLabel,
  Input,
  Switch,
  Button,
  useToast,
  Icon,
  useColorModeValue,
  Spinner,
  VStack,
  HStack,
  Badge,
  Card,
  CardBody,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Progress,
  Flex,
  Wrap,
  WrapItem,
  Radio,
  RadioGroup,
  Stack,
  useColorMode,
} from '@chakra-ui/react';
import {
  FaUserAlt,
  FaIdBadge,
  FaBuilding,
  FaUserEdit,
  FaFile,
  FaMap,
  FaProjectDiagram,
  FaMapMarkerAlt,
  FaBriefcase,
  FaKey,
  FaUserShield,
  FaCheckCircle,
  FaTimesCircle,
  FaHardHat,
  FaExclamationTriangle,
} from 'react-icons/fa';
import { GiOfficeChair } from 'react-icons/gi';
import { PhoneIcon, EditIcon, InfoIcon } from '@chakra-ui/icons';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import baseUrl from '../../../Base_Url/baseUrl';
import axiosInstance from 'axiosInstance';
const roleConfig = {
  admin: {
    label: 'Admin',
    icon: FaUserShield,
    color: 'purple',
    description: 'Full system access',
    requiresSchemes: false,
    requiresFileTypes: false,
    requiresTahsils: false,
    departmentType: 'none',
    allowedSchemes: 'all',
    canBeEditedBy: ['admin'],
  },
  schemeAdmin: {
    label: 'Office In Charge (OIC)',
    icon: FaUserShield,
    color: 'blue',
    description: 'Can manage users for assigned schemes',
    requiresSchemes: true,
    requiresFileTypes: false,
    requiresTahsils: false,
    departmentType: 'multiple',
    allowedSchemes: 'all',
    canBeEditedBy: ['admin'],
  },
  talukaUser: {
    label: 'Tehsildar',
    icon: FaMapMarkerAlt,
    color: 'green',
    description: 'For taluka-level operations',
    requiresSchemes: true,
    requiresFileTypes: false,
    requiresTahsils: true,
    departmentType: 'single',
    allowedSchemes: 'general',
    canBeEditedBy: ['admin', 'schemeAdmin'],
  },
  departmentOfficer: {
    label: 'Department Officer',
    icon: FaBriefcase,
    color: 'teal',
    description: 'Department-level officer',
    requiresSchemes: true,
    requiresFileTypes: false,
    requiresTahsils: false,
    departmentType: 'single',
    allowedSchemes: 'general',
    canBeEditedBy: ['admin'],
  },
  projectOfficer: {
    label: 'Project Officer',
    icon: FaHardHat,
    color: 'purple',
    description: 'For PM-JANMAN scheme only',
    requiresSchemes: true,
    requiresFileTypes: true,
    requiresTahsils: false,
    departmentType: 'single',
    allowedSchemes: 'pmJanman',
    canBeEditedBy: ['admin', 'schemeAdmin'],
  },
  subDivisionalOfficer: {
    label: 'Sub Divisional Officer',
    icon: GiOfficeChair,
    color: 'red',
    description: 'For Land Acquisition & Big Projects scheme only',
    requiresSchemes: true,
    requiresFileTypes: true,
    requiresTahsils: false,
    departmentType: 'single',
    allowedSchemes: 'landAcquisition',
    canBeEditedBy: ['admin', 'schemeAdmin'],
  },
};

const schemeRoleMapping = {
  '68ee2171ad9b09bdda13b4f6': {
    name: 'PM-JANMAN',
    type: 'pmJanman',
    allowedRoles: ['projectOfficer', 'departmentOfficer', 'schemeAdmin'],
    color: 'purple',
    description: 'Project Officer only scheme',
  },
  '68d135b1e18cfc3e5248edc2': {
    name: 'Land Acquisition & Big Projects',
    type: 'landAcquisition',
    allowedRoles: ['subDivisionalOfficer', 'departmentOfficer', 'schemeAdmin'],
    color: 'red',
    description: 'Sub Divisional Officer only scheme',
  },
};

const EditUserModal = ({
  isOpen,
  onClose,
  editUser,
  setEditUser,
  roleOptions,
  token,
  getUsers,
}) => {
  console.log('EditUserModal render', { editUser });
  const { colorMode } = useColorMode();
  const toast = useToast();
  const { t } = useTranslation();
  const [isEditingSelf, setIsEditingSelf] = useState(false);

  const modalBg = useColorModeValue('white', 'gray.800');
  const modalTextColor = useColorModeValue('gray.800', 'white');
  const subtitleColor = useColorModeValue('gray.600', 'gray.300');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const inputBg = useColorModeValue('white', 'gray.700');
  const cardBg = useColorModeValue('white', 'gray.800');
  const footerBg = useColorModeValue('gray.50', 'gray.900');

  const optionBg = useColorModeValue('#edf2f7', '#2D3748');
  const multiValueBg = useColorModeValue('#e2e8f0', '#4A5568');
  const multiValueText = useColorModeValue('gray.800', 'white');
  const multiValueRemoveText = useColorModeValue('gray.600', 'gray.300');

  const inputTextColor = useColorModeValue('gray.800', 'white');
  const inputPlaceholderColor = useColorModeValue('gray.500', 'gray.400');
  const labelColor = useColorModeValue('gray.700', 'gray.200');
  const hoverBorderColor = useColorModeValue('blue.400', 'blue.300');
  const focusBorderColor = useColorModeValue('blue.500', 'blue.400');
  const DeptBG = useColorModeValue('gray.50', 'gray.700');
  const alertInfoBg = useColorModeValue('blue.50', 'blue.900');
  const alertInfoColor = useColorModeValue('blue.800', 'blue.100');
  const alertIconColor = useColorModeValue('blue.500', 'blue.300');
  const radioBorder = useColorModeValue('gray.200', 'gray.600');

  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [filteredRoles, setFilteredRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [schemes, setSchemes] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [fileTypes, setFileTypes] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);
  const [selectedSchemes, setSelectedSchemes] = useState([]);
  const [selectedTahsils, setSelectedTahsils] = useState([]);
  const [selectedFileTypes, setSelectedFileTypes] = useState([]);
  const [selectedSubDivision, setSelectedSubDivision] = useState(null);
  const [loadingSchemes, setLoadingSchemes] = useState(false);
  const [loadingFileTypes, setLoadingFileTypes] = useState(false);
  const [loadingSubDivisions, setLoadingSubDivisions] = useState(false);
  const [loadingTalukas, setLoadingTalukas] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [isDepartmentDisabled, setIsDepartmentDisabled] = useState(false);
  const [isSchemeDisabled, setIsSchemeDisabled] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [selectedSchemeIds, setSelectedSchemeIds] = useState([]);
  const [selectedSchemeType, setSelectedSchemeType] = useState(null);
  const [compatibleRoles, setCompatibleRoles] = useState([]);
  const [loginRole, setLoginRole] = useState('');
  const [userDepartment, setUserDepartment] = useState([]);
  const [userSchemes, setUserSchemes] = useState([]);
  const [formProgress, setFormProgress] = useState(0);
  const [step, setStep] = useState(1);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [availableDepartments, setAvailableDepartments] = useState([]);

  const getCurrentUserData = useCallback(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      const parsed = JSON.parse(userData);
      setLoginRole(parsed.role);
      setUserDepartment(parsed.department || []);
      setUserSchemes(parsed.schemes || []);
      return parsed;
    }
    return null;
  }, []);

  const getAllowedRolesForEditor = (editorRole) => {
    if (!editorRole) return [];

    const allowedRoles = [];

    Object.keys(roleConfig).forEach((role) => {
      if (roleConfig[role].canBeEditedBy?.includes(editorRole)) {
        allowedRoles.push(role);
      }
    });

    return allowedRoles;
  };

  useEffect(() => {
    if (isOpen && editUser) {
      const currentUser = getCurrentUserData();
      if (currentUser && editUser._id === currentUser._id) {
        setIsEditingSelf(true);
      } else {
        setIsEditingSelf(false);
      }
    }
  }, [isOpen, editUser, getCurrentUserData]);

  useEffect(() => {
    if (isOpen) {
      const userData = getCurrentUserData();
      if (userData) {
        const allowedRoles = getAllowedRolesForEditor(userData.role);

        setFilteredRoles(
          allowedRoles.map((role) => ({
            value: role,
            label: roleConfig[role].label,
            icon: roleConfig[role].icon,
            color: roleConfig[role].color,
            description: roleConfig[role].description,
            departmentType: roleConfig[role].departmentType,
            allowedSchemes: roleConfig[role].allowedSchemes,
          })),
        );

        if (userData.role === 'admin') {
          setIsDepartmentDisabled(false);
          setIsSchemeDisabled(false);
        } else if (userData.role === 'schemeAdmin') {
          setIsDepartmentDisabled(true);
          setIsSchemeDisabled(false);
        } else {
          setIsDepartmentDisabled(true);
          setIsSchemeDisabled(true);
        }
      }
    }
  }, [isOpen, getCurrentUserData]);

  useEffect(() => {
    let progress = 0;

    if (editUser?.name && editUser?.phoneNo && editUser?.userId) progress += 25;

    if (editUser?.role) progress += 25;

    if (editUser?.role !== 'admin') {
      const roleCfg = roleConfig[editUser?.role];
      if (roleCfg && selectedDepartment.length > 0) {
        if (
          roleCfg.departmentType === 'multiple' &&
          selectedDepartment.length >= 1
        ) {
          progress += 25;
        } else if (
          roleCfg.departmentType === 'single' &&
          selectedDepartment.length === 1
        ) {
          progress += 25;
        }
      }
    }

    if (editUser?.role && selectedSchemes.length > 0) progress += 25;

    setFormProgress(Math.min(progress, 100));

    if (!editUser?.role) setStep(1);
    else if (!selectedDepartment || selectedDepartment.length === 0) setStep(2);
    else if (!selectedSchemes || selectedSchemes.length === 0) setStep(3);
    else setStep(4);
  }, [editUser, selectedDepartment, selectedSchemes]);

  const fetchDepartments = async () => {
    try {
      setLoadingDepartments(true);
      const res = await axiosInstance.get(`${baseUrl}/master/all-department`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const deptArray = Array.isArray(res.data?.data?.data)
        ? res.data.data.data
        : [];
      setDepartments(deptArray);

      if (loginRole === 'schemeAdmin' && userDepartment.length > 0) {
        const userDeptIds = userDepartment.map((dept) =>
          typeof dept === 'object' ? dept._id : dept,
        );
        const filteredDepts = deptArray.filter((dept) =>
          userDeptIds.includes(dept._id),
        );
        setAvailableDepartments(filteredDepts);
      } else {
        setAvailableDepartments(deptArray);
      }

      return deptArray;
    } catch (err) {
      if (err.response?.status !== 401) {
        toast({
          title:
            err.response?.data?.message ||
            err.response?.data?.data ||
            t('Failed to load departments'),
          status: 'error',
          duration: 3000,
        });
      }
      return [];
    } finally {
      setLoadingDepartments(false);
    }
  };

  const fetchSchemes = async (departmentIds = []) => {
    try {
      setLoadingSchemes(true);

      if (!departmentIds || departmentIds.length === 0 || !editUser?.role) {
        setSchemes([]);
        return [];
      }

      let allSchemes = [];

      if (departmentIds.length > 1) {
        const fetchPromises = departmentIds.map(async (deptId) => {
          try {
            const params = { department: deptId };
            const schemeRes = await axiosInstance.get(
              `${baseUrl}/master/all-scheme`,
              {
                headers: { Authorization: `Bearer ${token}` },
                params,
              },
            );

            if (schemeRes.status === 200) {
              return schemeRes?.data?.data?.data || [];
            }
            return [];
          } catch (err) {
            return [];
          }
        });

        const schemesArrays = await Promise.all(fetchPromises);
        allSchemes = schemesArrays.flat();

        const uniqueSchemeIds = new Set();
        allSchemes = allSchemes.filter((scheme) => {
          if (uniqueSchemeIds.has(scheme._id)) {
            return false;
          }
          uniqueSchemeIds.add(scheme._id);
          return true;
        });
      } else {
        const departmentId = departmentIds[0];
        const params = { department: departmentId };
        const schemeRes = await axiosInstance.get(
          `${baseUrl}/master/all-scheme`,
          {
            headers: { Authorization: `Bearer ${token}` },
            params,
          },
        );

        if (schemeRes.status === 200) {
          allSchemes = schemeRes?.data?.data?.data || [];
        }
      }

      const roleCfg = roleConfig[editUser?.role];
      if (roleCfg?.allowedSchemes === 'pmJanman') {
        allSchemes = allSchemes.filter(
          (scheme) => scheme._id === '68ee2171ad9b09bdda13b4f6',
        );
      } else if (roleCfg?.allowedSchemes === 'landAcquisition') {
        allSchemes = allSchemes.filter(
          (scheme) => scheme._id === '68d135b1e18cfc3e5248edc2',
        );
      } else if (roleCfg?.allowedSchemes === 'general') {
        allSchemes = allSchemes.filter(
          (scheme) =>
            !['68ee2171ad9b09bdda13b4f6', '68d135b1e18cfc3e5248edc2'].includes(
              scheme._id,
            ),
        );
      }

      if (loginRole === 'schemeAdmin' && userSchemes.length > 0) {
        const userSchemeIds = userSchemes.map((s) =>
          typeof s === 'object' ? s._id : s,
        );
        allSchemes = allSchemes.filter((scheme) =>
          userSchemeIds.includes(scheme._id),
        );
      }

      setSchemes(allSchemes);
      return allSchemes;
    } catch (err) {
      if (err.response?.status !== 401) {
        toast({
          title:
            err.response?.data?.message ||
            err.response?.data?.data ||
            'Error fetching schemes',
          description: err.message,
          status: 'error',
          duration: 3000,
        });
      }
      return [];
    } finally {
      setLoadingSchemes(false);
    }
  };

  const fetchTalukas = async (subdivisionId = null) => {
    try {
      setLoadingTalukas(true);

      const params = {};
      if (subdivisionId) {
        params.subdivisionmain = subdivisionId;
      }

      const res = await axiosInstance.get(`${baseUrl}/master/all-tahsils`, {
        headers: { Authorization: `Bearer ${token}` },
        params: params,
      });

      const talukaData = res.data?.data?.data || [];
      setTalukas(talukaData);
      return talukaData;
    } catch (err) {
      if (err.response?.status !== 401) {
        toast({
          title:
            err.response?.data?.message ||
            err.response?.data?.data ||
            'Failed to load talukas',
          status: 'error',
          duration: 3000,
        });
      }
      return [];
    } finally {
      setLoadingTalukas(false);
    }
  };

  const fetchSubDivisions = async () => {
    try {
      setLoadingSubDivisions(true);
      const res = await axiosInstance.get(
        `${baseUrl}/master/all-subdivisionsmain`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      const subDivisionArray = Array.isArray(res.data?.data?.data?.data)
        ? res.data.data.data.data
        : [];
      setSubDivisions(subDivisionArray);
      return subDivisionArray;
    } catch (err) {
      if (err.response?.status !== 401) {
        toast({
          title:
            err.response?.data?.message ||
            err.response?.data?.data ||
            'Failed to load sub-divisions',
          status: 'error',
          duration: 3000,
        });
      }
      return [];
    } finally {
      setLoadingSubDivisions(false);
    }
  };

  const fetchFileTypes = async (schemeIds = [], departmentIds = []) => {
    try {
      setLoadingFileTypes(true);

      if (!schemeIds.length || !departmentIds.length) {
        setFileTypes([]);
        return [];
      }

      const departmentParam = Array.isArray(departmentIds)
        ? departmentIds.join(',')
        : departmentIds;

      const schemeIdsString = schemeIds.join(',');
      const response = await axiosInstance.get(
        `${baseUrl}/master/all-file-type`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            schemes: schemeIdsString,
            department: departmentParam,
          },
        },
      );

      if (response.data.status) {
        const fetchedFileTypes = response.data?.data?.data || [];
        const uniqueFileTypes = [];
        const seenIds = new Set();

        fetchedFileTypes.forEach((ft) => {
          if (!seenIds.has(ft._id)) {
            seenIds.add(ft._id);
            uniqueFileTypes.push(ft);
          }
        });

        const options = uniqueFileTypes.map((ft) => ({
          value: ft._id,
          label: `${ft.name}${ft.scheme?.name ? ` (${ft.scheme.name})` : ''}`,
        }));
        setFileTypes(options);
        return options;
      } else {
        setFileTypes([]);
        return [];
      }
    } catch (err) {
      if (err.response?.status !== 401) {
        toast({
          title:
            err.response?.data?.message ||
            err.response?.data?.data ||
            'Failed to load file types',
          status: 'error',
          duration: 3000,
        });
      }
      setFileTypes([]);
      return [];
    } finally {
      setLoadingFileTypes(false);
    }
  };

  const extractId = (item) => {
    if (!item) return null;
    if (typeof item === 'string') return item;
    if (typeof item === 'object' && item._id) return item._id;
    if (Array.isArray(item) && item.length > 0) {
      const firstItem = item[0];
      if (typeof firstItem === 'object' && firstItem._id) return firstItem._id;
      if (typeof firstItem === 'string') return firstItem;
    }
    return null;
  };

  const resetForm = useCallback(() => {
    setSelectedSchemes([]);
    setSelectedTahsils([]);
    setSelectedFileTypes([]);
    setSelectedSubDivision(null);
    setSelectedDepartment([]);
    setFileTypes([]);
    setTalukas([]);
    setSelectedSchemeIds([]);
    setSelectedSchemeType(null);
    setCompatibleRoles([]);
    setInitialized(false);
    setDataLoaded(false);
    setIsDepartmentDisabled(false);
    setIsSchemeDisabled(false);
    setFormProgress(0);
    setStep(1);
    setAvailableDepartments([]);

    if (setEditUser) {
      setEditUser(null);
    }
  }, [setEditUser]);

  const initializeForm = useCallback(async () => {
    if (!editUser) return;

    try {
      setDataLoaded(false);
      setSelectedSchemes([]);
      setSelectedTahsils([]);
      setSelectedFileTypes([]);
      setSelectedSubDivision(null);

      const [depts, subDivs] = await Promise.all([
        fetchDepartments(),
        fetchSubDivisions(),
      ]);

      const currentUser = getCurrentUserData();

      if (editUser.department && Array.isArray(editUser.department)) {
        const departmentOptions = editUser.department
          .map((dept) => {
            const deptId = typeof dept === 'object' ? dept._id : dept;
            const foundDepartment = depts.find((d) => d._id === deptId);
            return foundDepartment
              ? {
                  value: foundDepartment._id,
                  label: foundDepartment.name,
                }
              : null;
          })
          .filter(Boolean);

        setSelectedDepartment(departmentOptions);

        if (departmentOptions.length > 0) {
          const departmentIds = departmentOptions.map((dept) => dept.value);
          await fetchSchemes(departmentIds);
        }
      }

      if (editUser.role === 'talukaUser') {
        await fetchTalukas(null);
      }

      setInitialized(true);
      setDataLoaded(true);
    } catch (error) {
      toast({
        title: 'Failed to load form data',
        status: 'error',
        duration: 3000,
      });
    }
  }, [editUser, getCurrentUserData, toast]);

  useEffect(() => {
    if (isOpen && editUser) {
      initializeForm();
    } else {
      resetForm();
    }
  }, [isOpen, editUser?._id]);

  useEffect(() => {
    if (
      departments.length > 0 &&
      editUser?.department &&
      !selectedDepartment.length
    ) {
      const departmentOptions = editUser.department
        .map((dept) => {
          const deptId = typeof dept === 'object' ? dept._id : dept;
          const foundDepartment = departments.find((d) => d._id === deptId);
          return foundDepartment
            ? {
                value: foundDepartment._id,
                label: foundDepartment.name,
              }
            : null;
        })
        .filter(Boolean);

      setSelectedDepartment(departmentOptions);

      if (departmentOptions.length > 0 && editUser.role) {
        const departmentIds = departmentOptions.map((dept) => dept.value);
        fetchSchemes(departmentIds);
      }
    }
  }, [
    departments,
    editUser?.department,
    editUser?.role,
    selectedDepartment.length,
  ]);

  useEffect(() => {
    if (editUser?.role && selectedDepartment.length > 0) {
      fetchSchemes(selectedDepartment.map((dept) => dept.value));
    }
  }, [editUser?.role, selectedDepartment]);

  useEffect(() => {
    if (schemes.length > 0 && editUser?.schemes && !selectedSchemes.length) {
      const schemeOptions = editUser.schemes
        .map((scheme) => {
          const schemeId = extractId(scheme);
          const foundScheme = schemes.find((s) => s._id === schemeId);
          return foundScheme
            ? {
                value: foundScheme._id,
                label: foundScheme.name,
                color: schemeRoleMapping[foundScheme._id]?.color || 'blue',
              }
            : null;
        })
        .filter(Boolean);

      setSelectedSchemes(schemeOptions);
      setSelectedSchemeIds(schemeOptions.map((s) => s.value));

      if (
        ['projectOfficer', 'subDivisionalOfficer'].includes(editUser.role) &&
        schemeOptions.length > 0 &&
        selectedDepartment.length > 0
      ) {
        const schemeIds = schemeOptions.map((s) => s.value);
        const departmentIds = selectedDepartment.map((dept) => dept.value);
        fetchFileTypes(schemeIds, departmentIds);
      }
    }
  }, [
    schemes,
    editUser?.schemes,
    editUser?.role,
    selectedSchemes.length,
    selectedDepartment,
  ]);

  useEffect(() => {
    if (
      talukas.length > 0 &&
      editUser?.role === 'talukaUser' &&
      editUser?.tahsils &&
      !selectedTahsils.length
    ) {
      const tahsilOptions = editUser.tahsils
        .map((tahsil) => {
          const tahsilId = extractId(tahsil);
          const foundTaluka = talukas.find((t) => t._id === tahsilId);
          return foundTaluka
            ? {
                value: foundTaluka._id,
                label: foundTaluka.name,
              }
            : null;
        })
        .filter(Boolean);
      setSelectedTahsils(tahsilOptions);
    }
  }, [talukas, editUser?.role, editUser?.tahsils, selectedTahsils.length]);

  useEffect(() => {
    if (
      fileTypes.length > 0 &&
      ['projectOfficer', 'subDivisionalOfficer'].includes(editUser?.role) &&
      editUser?.fileTypes &&
      !selectedFileTypes.length
    ) {
      const fileTypeOptions = editUser.fileTypes
        .map((ft) => {
          const ftId = extractId(ft);
          const foundFt = fileTypes.find((f) => f.value === ftId);
          return foundFt ? foundFt : null;
        })
        .filter(Boolean);

      setSelectedFileTypes(fileTypeOptions);
    }
  }, [
    fileTypes,
    editUser?.role,
    editUser?.fileTypes,
    selectedFileTypes.length,
  ]);

  useEffect(() => {
    if (
      subDivisions.length > 0 &&
      editUser?.role === 'subDivisionalOfficer' &&
      editUser?.subDivision &&
      !selectedSubDivision
    ) {
      const subDivisionId = extractId(editUser.subDivision);
      const foundSubDivision = subDivisions.find(
        (sd) => sd._id === subDivisionId,
      );
      if (foundSubDivision) {
        setSelectedSubDivision({
          value: foundSubDivision._id,
          label: foundSubDivision.name,
        });
      }
    }
  }, [
    subDivisions,
    editUser?.role,
    editUser?.subDivision,
    selectedSubDivision,
  ]);

  useEffect(() => {
    const initializeFileTypes = async () => {
      if (
        ['projectOfficer', 'subDivisionalOfficer'].includes(editUser?.role) &&
        editUser?.fileTypes &&
        selectedSchemeIds.length > 0 &&
        selectedDepartment.length > 0 &&
        selectedFileTypes.length === 0
      ) {
        const departmentIds = selectedDepartment.map((dept) => dept.value);
        await fetchFileTypes(selectedSchemeIds, departmentIds);

        setTimeout(() => {
          if (fileTypes.length > 0) {
            const fileTypeOptions = editUser.fileTypes
              .map((ft) => {
                const ftId = extractId(ft);
                const foundFt = fileTypes.find((f) => f.value === ftId);
                return foundFt ? foundFt : null;
              })
              .filter(Boolean);

            setSelectedFileTypes(fileTypeOptions);
          }
        }, 100);
      }
    };

    initializeFileTypes();
  }, [
    editUser?.role,
    editUser?.fileTypes,
    selectedSchemeIds,
    selectedDepartment,
    selectedFileTypes.length,
  ]);

  const handleUpdate = async () => {
    try {
      const updatePayload = {
        name: editUser?.name,
        phoneNo: editUser?.phoneNo,
        role: editUser?.role,
        userId: editUser?.userId,
        active: editUser?.active,
      };

      if (editUser?.role !== 'admin') {
        updatePayload.department = selectedDepartment.map((dept) => dept.value);
        updatePayload.nameOfOffice = editUser?.nameOfOffice || '';
        updatePayload.designation = editUser?.designation || '';
        updatePayload.schemes = selectedSchemes.map((s) => s.value);
      }

      if (editUser?.role === 'subDivisionalOfficer') {
        updatePayload.subDivision = selectedSubDivision?.value || '';
      }

      if (editUser?.role === 'talukaUser') {
        updatePayload.tahsils = selectedTahsils.map((t) => t.value);
      }

      if (['projectOfficer', 'subDivisionalOfficer'].includes(editUser?.role)) {
        updatePayload.fileTypes = selectedFileTypes.map((ft) => ft.value);
      }

      await axiosInstance.put(
        `${baseUrl}/auth/updateUser/${editUser._id}`,
        updatePayload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      toast({
        title: t('User updated'),
        status: 'success',
        duration: 3000,
      });
      onClose();
      getUsers();
    } catch (e) {
      if (e?.response?.status !== 401) {
        toast({
          title:
            e?.response?.data?.message ||
            e?.response?.data?.data ||
            t('Update failed'),
          status: 'error',
          duration: 3000,
        });
      }
    }
  };

  const handleClose = () => {
    resetForm();
    if (setEditUser) {
      setEditUser(null);
    }
    onClose();
  };

  const onRoleChange = (value) => {
    const oldRoleCfg = roleConfig[editUser?.role];
    const newRoleCfg = roleConfig[value];

    setEditUser((prev) => ({
      ...prev,
      role: value,
      schemes: [],
      fileTypes: [],
      tahsils: [],
      subDivision: '',
    }));

    setSelectedSchemes([]);
    setSelectedFileTypes([]);
    setSelectedTahsils([]);
    setSelectedSubDivision(null);

    if (
      oldRoleCfg?.departmentType === 'multiple' &&
      newRoleCfg?.departmentType === 'single' &&
      selectedDepartment.length > 1
    ) {
      const firstDepartment = selectedDepartment[0];
      setSelectedDepartment([firstDepartment]);
    }

    if (selectedDepartment.length > 0) {
      const departmentIds = selectedDepartment.map((dept) => dept.value);
      fetchSchemes(departmentIds);
    }
  };

  const onDepartmentChange = (selectedOptions) => {
    const roleCfg = roleConfig[editUser?.role];
    const isMultiSelect = roleCfg?.departmentType === 'multiple';

    let departmentOptions = [];

    if (isMultiSelect) {
      departmentOptions = Array.isArray(selectedOptions) ? selectedOptions : [];
    } else {
      departmentOptions = selectedOptions ? [selectedOptions] : [];
    }

    setSelectedDepartment(departmentOptions);

    setEditUser((prev) => ({
      ...prev,
      department: departmentOptions.map((opt) => opt.value),
      schemes: [],
    }));

    setSelectedSchemes([]);
    setSelectedSchemeIds([]);

    if (editUser?.role && departmentOptions.length > 0) {
      const departmentIds = departmentOptions.map((dept) => dept.value);
      fetchSchemes(departmentIds);
    }
  };

  const onSchemesChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((opt) => opt.value)
      : [];

    setSelectedSchemeIds(selectedValues);
    setSelectedSchemes(selectedOptions || []);
    setSelectedFileTypes([]);

    setEditUser((prev) => ({
      ...prev,
      schemes: selectedValues,
      fileTypes: [],
    }));

    if (selectedValues.length > 0 && selectedDepartment.length > 0) {
      const departmentIds = selectedDepartment.map((dept) => dept.value);
      fetchFileTypes(selectedValues, departmentIds);
    }
  };

  const onSubDivisionChange = (selectedOption) => {
    const subDivisionId = selectedOption?.value || '';
    setSelectedSubDivision(selectedOption);

    setEditUser((prev) => ({
      ...prev,
      subDivision: subDivisionId,
    }));

    if (editUser?.role === 'talukaUser') {
      setSelectedTahsils([]);
    }
  };

  const mappedAvailableDepartments = availableDepartments.map((d) => ({
    value: d._id,
    label: d.name,
  }));

  const mappedSchemes = schemes.map((item) => ({
    value: item._id,
    label: item.name,
    color: schemeRoleMapping[item._id]?.color || 'blue',
  }));

  const mappedTalukas = talukas.map((t) => ({
    value: t._id,
    label: t.name,
  }));

  const mappedSubDivisions = subDivisions.map((sd) => ({
    value: sd._id,
    label: `${sd.name}`,
  }));

  const shouldShowAdditionalFields =
    editUser?.role && editUser.role !== 'admin';

  const getRoleColor = (role) => {
    return roleConfig[role]?.color || 'gray';
  };

  const getRoleIcon = (role) => {
    return roleConfig[role]?.icon || FaUserAlt;
  };

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: inputBg,
      color: inputTextColor,
      borderColor: state.isFocused ? focusBorderColor : borderColor,
      borderWidth: '1px',
      borderRadius: 'lg',
      boxShadow: state.isFocused ? `0 0 0 1px ${focusBorderColor}` : 'none',
      '&:hover': {
        borderColor: state.isFocused ? focusBorderColor : hoverBorderColor,
      },
      minHeight: '40px',
      fontSize: '14px',
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: modalBg,
      color: modalTextColor,
      borderRadius: 'lg',
      border: '1px solid',
      borderColor: borderColor,
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? `${focusBorderColor} !important`
        : state.isFocused
        ? colorMode === 'light'
          ? 'gray.100'
          : 'gray.700'
        : modalBg,
      color: state.isSelected ? 'white' : modalTextColor,
      fontSize: '14px',
      padding: '10px 12px',
      '&:hover': {
        backgroundColor: state.isSelected
          ? focusBorderColor
          : colorMode === 'light'
          ? 'gray.100'
          : 'gray.700',
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: modalTextColor,
    }),
    placeholder: (base) => ({
      ...base,
      color: inputPlaceholderColor,
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: multiValueBg,
      borderRadius: 'md',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: multiValueText,
      fontWeight: '500',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: multiValueRemoveText,
      '&:hover': {
        backgroundColor: 'red.500',
        color: 'white',
      },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    input: (base) => ({
      ...base,
      color: inputTextColor,
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: borderColor,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: borderColor,
      '&:hover': {
        color: hoverBorderColor,
      },
    }),
    noOptionsMessage: (base) => ({
      ...base,
      color: subtitleColor,
      backgroundColor: modalBg,
    }),
    loadingMessage: (base) => ({
      ...base,
      color: subtitleColor,
      backgroundColor: modalBg,
    }),
  };
  const isFormValid = () => {
    const { name, phoneNo, role, userId, nameOfOffice, designation } =
      editUser || {};
    const roleCfg = roleConfig[role];

    if (!name || !phoneNo || !role || !userId) return false;

    if (role === 'admin') return true;

    if (!roleCfg) return false;

    if (role !== 'admin') {
      if (!nameOfOffice || !designation) return false;
      if (!selectedDepartment || selectedDepartment.length === 0) return false;
      if (
        roleCfg?.departmentType === 'single' &&
        selectedDepartment.length !== 1
      )
        return false;
      if (
        roleCfg?.requiresSchemes &&
        (!selectedSchemes || selectedSchemes.length === 0)
      )
        return false;
      if (role === 'subDivisionalOfficer' && !selectedSubDivision) return false;
      if (
        role === 'talukaUser' &&
        (!selectedTahsils || selectedTahsils.length === 0)
      )
        return false;
      if (
        ['projectOfficer', 'subDivisionalOfficer'].includes(role) &&
        (!selectedFileTypes || selectedFileTypes.length === 0)
      )
        return false;
    }

    return true;
  };

  const renderRoleSelection = () => (
    <Card
      mb={6}
      boxShadow="sm"
      border="1px solid"
      borderColor={borderColor}
      bg={cardBg}
    >
      <CardBody>
        <VStack align="start" spacing={4}>
          <HStack spacing={2}>
            <Icon as={FaKey} color="purple.500" />
            <Text fontSize="lg" fontWeight="semibold" color={modalTextColor}>
              Step 1: Select Role
            </Text>
          </HStack>

          <Text fontSize="sm" color={subtitleColor} mb={4}>
            Choose the role that best fits the user's responsibilities. This
            will determine what departments and schemes they can access.
          </Text>

          <RadioGroup value={editUser?.role} onChange={onRoleChange}>
            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
              {filteredRoles.map((role) => {
                const config = roleConfig[role.value];
                const isSelected = editUser?.role === role.value;

                // Dark mode compatible colors
                const selectedBgLight = '50';
                const selectedBgDark = '900';
                const selectedBg =
                  colorMode === 'light'
                    ? `${config.color}.${selectedBgLight}`
                    : `${config.color}.${selectedBgDark}`;

                return (
                  <Card
                    key={role.value}
                    role="button"
                    cursor="pointer"
                    onClick={() => onRoleChange(role.value)}
                    borderWidth="1px"
                    borderColor={
                      isSelected ? `${config.color}.400` : borderColor
                    }
                    bg={isSelected ? selectedBg : cardBg}
                    _hover={{
                      borderColor: `${config.color}.400`,
                      transform: 'translateY(-2px)',
                      boxShadow: 'md',
                    }}
                    transition="all 0.2s"
                    minH="130px"
                  >
                    <CardBody p={4}>
                      <HStack align="start" spacing={3}>
                        <Icon
                          as={config.icon}
                          fontSize="22px"
                          color={`${config.color}.400`}
                          mt={1}
                        />

                        <VStack align="start" spacing={1}>
                          <Text
                            fontWeight="semibold"
                            fontSize="sm"
                            color={modalTextColor}
                          >
                            {config.label}
                          </Text>

                          <Text
                            fontSize="xs"
                            color={subtitleColor}
                            noOfLines={2}
                          >
                            {config.description}
                          </Text>

                          <Badge
                            mt={2}
                            colorScheme={config.color}
                            variant={isSelected ? 'solid' : 'subtle'}
                            fontSize="10px"
                          >
                            {config.departmentType === 'multiple'
                              ? 'Multiple Departments'
                              : 'Single Department'}
                          </Badge>
                        </VStack>
                      </HStack>
                    </CardBody>
                  </Card>
                );
              })}
            </SimpleGrid>
          </RadioGroup>

          {editUser?.role && (
            <Box mt={2}>
              <Badge
                colorScheme={getRoleColor(editUser?.role)}
                fontSize="sm"
                px={3}
                py={1}
                borderRadius="full"
              >
                <HStack spacing={2}>
                  <Icon as={getRoleIcon(editUser?.role)} />
                  <Text>{roleConfig[editUser?.role]?.label}</Text>
                </HStack>
              </Badge>
            </Box>
          )}
        </VStack>
      </CardBody>
    </Card>
  );

  const renderDepartmentSelection = () => {
    if (!editUser?.role) return null;

    if (editUser?.role === 'admin') return null;

    const roleCfg = roleConfig[editUser.role];

    if (!roleCfg) return null;

    const isMultiSelect = roleCfg.departmentType === 'multiple';

    const canChooseDepartments = loginRole !== 'schemeAdmin';

    return (
      <Card
        mb={6}
        boxShadow="sm"
        border="1px solid"
        borderColor={borderColor}
        bg={cardBg}
      >
        <CardBody>
          <VStack align="start" spacing={4}>
            <HStack spacing={2}>
              <Icon as={FaBriefcase} color="teal.500" />
              <Text fontSize="lg" fontWeight="semibold" color={modalTextColor}>
                Step 2: Select Department{isMultiSelect ? 's' : ''}
              </Text>
            </HStack>

            <Text fontSize="sm" color={subtitleColor} mb={4}>
              {isMultiSelect
                ? 'Select one or more departments this user will manage'
                : 'Select the department this user will belong to'}
            </Text>

            <FormControl isRequired>
              <FormLabel fontSize="sm" fontWeight="medium" color={labelColor}>
                Department{isMultiSelect ? 's' : ''}
                {loadingDepartments && <Spinner size="sm" ml={2} />}
              </FormLabel>

              {loginRole === 'schemeAdmin' ? (
                <Box
                  p={2}
                  border="1px solid"
                  borderColor={borderColor}
                  borderRadius="lg"
                  bg="blue.50"
                >
                  <Text color="blue.700" fontWeight="medium">
                    {userDepartment
                      .map((dept) =>
                        typeof dept === 'object' ? dept.name : 'Department',
                      )
                      .join(', ')}
                  </Text>
                  <Text fontSize="xs" color="blue.600" mt={1}>
                    Your assigned departments (cannot be changed)
                  </Text>
                </Box>
              ) : (
                <>
                  {loadingDepartments ? (
                    <HStack spacing={2}>
                      <Spinner size="sm" />
                      <Text fontSize="sm" color={subtitleColor}>
                        Loading departments...
                      </Text>
                    </HStack>
                  ) : mappedAvailableDepartments.length === 0 ? (
                    <Alert status="warning" size="sm">
                      <AlertIcon />
                      No departments available
                    </Alert>
                  ) : (
                    <Select
                      options={mappedAvailableDepartments}
                      styles={selectStyles}
                      value={selectedDepartment}
                      onChange={onDepartmentChange}
                      placeholder={
                        isMultiSelect
                          ? 'Select one or more departments'
                          : 'Select department'
                      }
                      isMulti={isMultiSelect}
                      isDisabled={isDepartmentDisabled}
                    />
                  )}
                </>
              )}
            </FormControl>

            {selectedDepartment.length > 0 && (
              <Box w="full">
                <Text
                  fontSize="sm"
                  fontWeight="medium"
                  color={labelColor}
                  mb={2}
                >
                  Selected Department{selectedDepartment.length > 1 ? 's' : ''}{' '}
                  ({selectedDepartment.length})
                </Text>
                <Wrap spacing={2}>
                  {selectedDepartment.map((dept) => (
                    <WrapItem key={dept.value}>
                      <Badge
                        colorScheme="blue"
                        px={3}
                        py={1}
                        borderRadius="full"
                      >
                        {dept.label}
                      </Badge>
                    </WrapItem>
                  ))}
                </Wrap>
              </Box>
            )}
          </VStack>
        </CardBody>
      </Card>
    );
  };
  const renderSchemeSelection = () => {
    if (
      !editUser?.role ||
      !selectedDepartment ||
      selectedDepartment.length === 0
    )
      return null;

    if (editUser?.role === 'admin') return null;

    const roleCfg = roleConfig[editUser.role];

    if (!roleCfg) return null; // Safety check

    const availableSchemes = schemes.filter((scheme) => {
      if (loginRole === 'schemeAdmin' && userSchemes.length > 0) {
        const userSchemeIds = userSchemes.map((s) =>
          typeof s === 'object' ? s._id : s,
        );
        return userSchemeIds.includes(scheme._id);
      }
      return true;
    });

    const filteredMappedSchemes = availableSchemes.map((item) => ({
      value: item._id,
      label: item.name,
      color: schemeRoleMapping[item._id]?.color || 'blue',
    }));

    return (
      <Card
        mb={6}
        boxShadow="sm"
        border="1px solid"
        borderColor={borderColor}
        bg={cardBg}
      >
        <CardBody>
          <VStack align="start" spacing={4}>
            <HStack spacing={2}>
              <Icon as={FaProjectDiagram} color="green.500" />
              <Text fontSize="lg" fontWeight="semibold" color={modalTextColor}>
                Step 3: Select Scheme(s)
              </Text>
            </HStack>

            <Text fontSize="sm" color={subtitleColor} mb={4}>
              {roleCfg?.allowedSchemes === 'pmJanman'
                ? 'PM-JANMAN scheme is automatically selected for Project Officer'
                : roleCfg?.allowedSchemes === 'landAcquisition'
                ? 'Land Acquisition scheme is automatically selected for Sub Divisional Officer'
                : 'Select scheme(s) this user will work with'}
            </Text>

            <FormControl isRequired={roleCfg?.requiresSchemes}>
              <FormLabel fontSize="sm" fontWeight="medium" color={labelColor}>
                Scheme(s)
              </FormLabel>

              {loadingSchemes ? (
                <HStack spacing={2}>
                  <Spinner size="sm" />
                  <Text fontSize="sm" color={subtitleColor}>
                    Loading schemes...
                  </Text>
                </HStack>
              ) : filteredMappedSchemes.length === 0 ? (
                <Alert status="info" size="sm">
                  <AlertIcon />
                  No schemes available for the selected department and role
                </Alert>
              ) : (
                <Select
                  options={filteredMappedSchemes}
                  styles={selectStyles}
                  value={selectedSchemes}
                  onChange={onSchemesChange}
                  placeholder="Select scheme(s)"
                  isMulti
                  isDisabled={isSchemeDisabled}
                  menuPortalTarget={document.body}
                />
              )}
            </FormControl>

            {selectedSchemes.length > 0 && (
              <Box w="full">
                <Text
                  fontSize="sm"
                  fontWeight="medium"
                  color={labelColor}
                  mb={2}
                >
                  Selected Scheme(s) ({selectedSchemes.length})
                </Text>
                <Wrap spacing={2}>
                  {selectedSchemes.map((scheme) => {
                    const schemeInfo = schemeRoleMapping[scheme.value];
                    return (
                      <WrapItem key={scheme.value}>
                        <Badge
                          colorScheme={schemeInfo?.color || 'blue'}
                          px={3}
                          py={1}
                          borderRadius="full"
                        >
                          {scheme.label}
                        </Badge>
                      </WrapItem>
                    );
                  })}
                </Wrap>
              </Box>
            )}
          </VStack>
        </CardBody>
      </Card>
    );
  };

  const renderAdditionalFields = () => {
    if (!editUser?.role) return null;

    if (editUser.role === 'admin') return null;

    const roleCfg = roleConfig[editUser.role];
    if (!roleCfg) return null;

    return (
      <Card
        mb={6}
        boxShadow="sm"
        border="1px solid"
        borderColor={borderColor}
        bg={cardBg}
      >
        <CardBody>
          <VStack align="start" spacing={4}>
            <HStack spacing={2}>
              <Icon as={FaBuilding} color="orange.500" />
              <Text fontSize="lg" fontWeight="semibold" color={modalTextColor}>
                Office Details
              </Text>
            </HStack>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} w="full">
              {editUser?.role === 'subDivisionalOfficer' && (
                <FormControl isRequired>
                  <FormLabel
                    fontSize="sm"
                    fontWeight="medium"
                    color={labelColor}
                  >
                    Sub-Division
                  </FormLabel>
                  {loadingSubDivisions ? (
                    <HStack spacing={2}>
                      <Spinner size="sm" />
                      <Text fontSize="sm" color={subtitleColor}>
                        Loading sub-divisions...
                      </Text>
                    </HStack>
                  ) : (
                    <Select
                      options={mappedSubDivisions}
                      styles={selectStyles}
                      value={selectedSubDivision}
                      onChange={onSubDivisionChange}
                      placeholder="Select sub-division"
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  )}
                </FormControl>
              )}

              <FormControl isRequired>
                <FormLabel fontSize="sm" fontWeight="medium" color={labelColor}>
                  Designation
                </FormLabel>
                <Input
                  value={editUser?.designation || ''}
                  onChange={(e) =>
                    setEditUser((prev) => ({
                      ...prev,
                      designation: e.target.value,
                    }))
                  }
                  placeholder="Enter designation"
                  bg={inputBg}
                  borderColor={borderColor}
                  color={inputTextColor}
                  _placeholder={{ color: inputPlaceholderColor }}
                  _hover={{ borderColor: hoverBorderColor }}
                  _focus={{
                    borderColor: focusBorderColor,
                    boxShadow: `0 0 0 1px ${focusBorderColor}`,
                  }}
                />
              </FormControl>
            </SimpleGrid>

            <FormControl isRequired w="full">
              <FormLabel fontSize="sm" fontWeight="medium" color={labelColor}>
                Office Name
              </FormLabel>
              <Input
                value={editUser?.nameOfOffice || ''}
                onChange={(e) =>
                  setEditUser((prev) => ({
                    ...prev,
                    nameOfOffice: e.target.value,
                  }))
                }
                placeholder="Enter office name"
                bg={inputBg}
                borderColor={borderColor}
                color={inputTextColor}
                _placeholder={{ color: inputPlaceholderColor }}
                _hover={{ borderColor: hoverBorderColor }}
                _focus={{
                  borderColor: focusBorderColor,
                  boxShadow: `0 0 0 1px ${focusBorderColor}`,
                }}
              />
            </FormControl>
          </VStack>
        </CardBody>
      </Card>
    );
  };

  const renderTalukaAssignment = () => {
    if (editUser?.role !== 'talukaUser') return null;

    return (
      <Card
        mb={6}
        boxShadow="sm"
        border="1px solid"
        borderColor={borderColor}
        bg={cardBg}
      >
        <CardBody>
          <VStack align="start" spacing={4}>
            <HStack spacing={2}>
              <Icon as={FaMapMarkerAlt} color="green.500" />
              <Text fontSize="lg" fontWeight="semibold" color={modalTextColor}>
                Taluka Assignment
              </Text>
            </HStack>

            <FormControl isRequired w="full">
              <FormLabel fontSize="sm" fontWeight="medium" color={labelColor}>
                Select Taluka(s)
              </FormLabel>
              {loadingTalukas ? (
                <HStack spacing={2}>
                  <Spinner size="sm" />
                  <Text fontSize="sm" color={subtitleColor}>
                    Loading talukas...
                  </Text>
                </HStack>
              ) : mappedTalukas.length === 0 ? (
                <Alert status="warning" size="sm" borderRadius="md">
                  <AlertIcon boxSize={3} />
                  <AlertDescription fontSize="xs" color={subtitleColor}>
                    No talukas available
                  </AlertDescription>
                </Alert>
              ) : (
                <Select
                  options={mappedTalukas}
                  styles={selectStyles}
                  value={selectedTahsils}
                  onChange={(selected) => {
                    setSelectedTahsils(selected || []);
                  }}
                  placeholder={
                    mappedTalukas.length === 0
                      ? 'No talukas available'
                      : 'Select one or more talukas'
                  }
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  isMulti
                  isDisabled={mappedTalukas.length === 0}
                />
              )}
            </FormControl>
          </VStack>
        </CardBody>
      </Card>
    );
  };

  const renderFileTypePermissions = () => {
    if (!['projectOfficer', 'subDivisionalOfficer'].includes(editUser?.role))
      return null;

    return (
      <Card
        mb={6}
        boxShadow="sm"
        border="1px solid"
        borderColor={borderColor}
        bg={cardBg}
      >
        <CardBody>
          <VStack align="start" spacing={4}>
            <HStack spacing={2}>
              <Icon as={FaFile} color="orange.500" />
              <Text fontSize="lg" fontWeight="semibold" color={modalTextColor}>
                File Type Permissions
              </Text>
            </HStack>

            <FormControl isRequired w="full">
              <FormLabel fontSize="sm" fontWeight="medium" color={labelColor}>
                Select File Type(s)
                <Text as="span" fontSize="xs" color={subtitleColor} ml={2}>
                  (Available for selected schemes)
                </Text>
              </FormLabel>
              {loadingFileTypes ? (
                <HStack spacing={2}>
                  <Spinner size="sm" />
                  <Text fontSize="sm" color={subtitleColor}>
                    Loading file types...
                  </Text>
                </HStack>
              ) : fileTypes.length === 0 && selectedSchemes.length > 0 ? (
                <Alert status="info" size="sm" borderRadius="md">
                  <AlertIcon boxSize={3} />
                  <AlertDescription fontSize="xs" color={subtitleColor}>
                    No file types found for selected schemes
                  </AlertDescription>
                </Alert>
              ) : selectedSchemes.length === 0 ? (
                <Text fontSize="sm" color={subtitleColor}>
                  Select schemes first to see available file types
                </Text>
              ) : (
                <Select
                  options={fileTypes}
                  styles={selectStyles}
                  value={selectedFileTypes}
                  onChange={(selected) => {
                    setSelectedFileTypes(selected || []);
                  }}
                  placeholder="Select one or more file types"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  isMulti
                />
              )}
            </FormControl>
          </VStack>
        </CardBody>
      </Card>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="4xl"
      scrollBehavior="outside"
      closeOnOverlayClick={false}
    >
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent
        rounded="xl"
        shadow="2xl"
        overflow="hidden"
        bg={modalBg}
        maxH="90vh"
      >
        <Box
          bgGradient="linear(to-r, purple.500, pink.600)"
          py={3}
          px={6}
          textAlign="center"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            color="white"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            p={0}
          >
            <HStack spacing={3}>
              <Icon as={FaUserEdit} boxSize={5} />
              <VStack align="start" spacing={0}>
                <Text fontSize="lg">Edit User: {editUser?.name}</Text>
                <Text fontSize="xs" opacity={0.9}>
                  ID: {editUser?.userId} • Step {step} of 4 •{' '}
                  {Math.round(formProgress)}% Complete
                </Text>
              </VStack>
            </HStack>
            <ModalCloseButton
              color="white"
              position="relative"
              top={0}
              right={0}
              _hover={{ bg: 'rgba(255,255,255,0.2)' }}
            />
          </ModalHeader>
        </Box>

        <ModalBody bg={modalBg} px={6} py={0} maxHeight="60vh" overflowY="auto">
          {!dataLoaded || loadingDepartments ? (
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              height="200px"
            >
              <Spinner size="xl" color="purple.500" thickness="3px" />
              <Text mt={4} fontSize="md" color={subtitleColor}>
                Loading user data...
              </Text>
            </Box>
          ) : (
            <>
              <Card
                mb={6}
                boxShadow="sm"
                border="1px solid"
                borderColor={borderColor}
                bg={cardBg}
              >
                <CardBody>
                  <VStack align="start" spacing={4}>
                    <HStack spacing={2}>
                      <Icon as={FaUserAlt} color="blue.500" />
                      <Text
                        fontSize="lg"
                        fontWeight="semibold"
                        color={modalTextColor}
                      >
                        Basic Information
                      </Text>
                    </HStack>

                    <SimpleGrid
                      columns={{ base: 1, md: 2 }}
                      spacing={4}
                      w="full"
                    >
                      <FormControl isRequired>
                        <FormLabel
                          fontSize="sm"
                          fontWeight="medium"
                          color={labelColor}
                        >
                          Full Name
                        </FormLabel>
                        <Input
                          value={editUser?.name || ''}
                          onChange={(e) =>
                            setEditUser((prev) => ({
                              ...prev,
                              name: e.target.value,
                            }))
                          }
                          placeholder="Enter full name"
                          bg={inputBg}
                          borderColor={borderColor}
                          color={inputTextColor}
                          _placeholder={{ color: inputPlaceholderColor }}
                          _hover={{ borderColor: hoverBorderColor }}
                          _focus={{
                            borderColor: focusBorderColor,
                            boxShadow: `0 0 0 1px ${focusBorderColor}`,
                          }}
                        />
                      </FormControl>

                      <FormControl isRequired>
                        <FormLabel
                          fontSize="sm"
                          fontWeight="medium"
                          color={labelColor}
                        >
                          Phone Number
                        </FormLabel>
                        <Input
                          value={editUser?.phoneNo || ''}
                          onChange={(e) =>
                            setEditUser((prev) => ({
                              ...prev,
                              phoneNo: e.target.value,
                            }))
                          }
                          placeholder="Enter phone number"
                          bg={inputBg}
                          borderColor={borderColor}
                          color={inputTextColor}
                          _placeholder={{ color: inputPlaceholderColor }}
                          _hover={{ borderColor: hoverBorderColor }}
                          _focus={{
                            borderColor: focusBorderColor,
                            boxShadow: `0 0 0 1px ${focusBorderColor}`,
                          }}
                        />
                      </FormControl>
                    </SimpleGrid>

                    <SimpleGrid
                      columns={{ base: 1, md: 2 }}
                      spacing={4}
                      w="full"
                    >
                      <FormControl isRequired>
                        <FormLabel
                          fontSize="sm"
                          fontWeight="medium"
                          color={labelColor}
                        >
                          User ID
                        </FormLabel>
                        <Input
                          value={editUser?.userId || ''}
                          onChange={(e) =>
                            setEditUser((prev) => ({
                              ...prev,
                              userId: e.target.value,
                            }))
                          }
                          placeholder="Enter unique user ID"
                          bg={inputBg}
                          borderColor={borderColor}
                          color={inputTextColor}
                          _placeholder={{ color: inputPlaceholderColor }}
                          _hover={{ borderColor: hoverBorderColor }}
                          _focus={{
                            borderColor: focusBorderColor,
                            boxShadow: `0 0 0 1px ${focusBorderColor}`,
                          }}
                        />
                      </FormControl>
                    </SimpleGrid>
                  </VStack>
                </CardBody>
              </Card>

              {renderRoleSelection()}
              {renderDepartmentSelection()}
              {renderSchemeSelection()}
              {renderAdditionalFields()}
              {renderTalukaAssignment()}
              {renderFileTypePermissions()}

              <Card
                mb={6}
                boxShadow="sm"
                border="1px solid"
                borderColor={borderColor}
                bg={cardBg}
              >
                <CardBody>
                  <VStack align="start" spacing={4}>
                    <HStack spacing={2}>
                      <Icon
                        as={editUser?.active ? FaCheckCircle : FaTimesCircle}
                        color={editUser?.active ? 'green.500' : 'red.500'}
                      />
                      <Text
                        fontSize="lg"
                        fontWeight="semibold"
                        color={modalTextColor}
                      >
                        Account Status
                      </Text>
                    </HStack>

                    <FormControl display="flex" alignItems="center" w="full">
                      <HStack spacing={4} w="full" justify="space-between">
                        <VStack align="start" spacing={1}>
                          <Text
                            fontSize="sm"
                            fontWeight="medium"
                            color={modalTextColor}
                          >
                            {editUser?.active
                              ? 'Active Account'
                              : 'Inactive Account'}
                          </Text>
                          <Text fontSize="xs" color={subtitleColor}>
                            {editUser?.active
                              ? 'User can access the system'
                              : 'User account is disabled'}
                          </Text>
                        </VStack>

                        <Switch
                          id="active-switch"
                          colorScheme="green"
                          isChecked={!!editUser?.active}
                          onChange={(e) =>
                            setEditUser((prev) => ({
                              ...prev,
                              active: e.target.checked,
                            }))
                          }
                          size="lg"
                        />
                      </HStack>
                    </FormControl>
                  </VStack>
                </CardBody>
              </Card>

              <Alert
                status="info"
                variant="subtle"
                borderRadius="lg"
                fontSize="sm"
                bg={alertInfoBg}
                color={alertInfoColor}
              >
                <AlertIcon color={alertIconColor} />
                <Box>
                  <AlertTitle fontSize="sm">Update Summary</AlertTitle>
                  <AlertDescription fontSize="xs">
                    {editUser?.active ? 'Activating' : 'Deactivating'} account •
                    Updating role to{' '}
                    <Badge
                      colorScheme={getRoleColor(editUser?.role)}
                      fontSize="xs"
                    >
                      {roleConfig[editUser?.role]?.label || editUser?.role}
                    </Badge>
                    {selectedDepartment?.length > 0 &&
                      ` • ${selectedDepartment.length} department(s)`}
                    {selectedSchemes?.length > 0 &&
                      ` • ${selectedSchemes.length} scheme(s)`}
                    {selectedTahsils?.length > 0 &&
                      ` • ${selectedTahsils.length} taluka(s)`}
                    {selectedFileTypes?.length > 0 &&
                      ` • ${selectedFileTypes.length} file type permission(s)`}
                  </AlertDescription>
                </Box>
              </Alert>
            </>
          )}
        </ModalBody>

        <ModalFooter
          bg={footerBg}
          borderTop="1px solid"
          borderColor={borderColor}
          px={6}
          py={4}
        >
          <HStack spacing={3} w="full" justify="space-between">
            <Button
              onClick={handleClose}
              variant="outline"
              colorScheme="gray"
              size="md"
              borderRadius="lg"
              borderColor={borderColor}
              color={modalTextColor}
              _hover={{ bg: useColorModeValue('gray.100', 'gray.700') }}
            >
              Cancel
            </Button>

            <HStack spacing={3}>
              <Button
                colorScheme="purple"
                onClick={handleUpdate}
                isDisabled={!isFormValid()}
                loadingText="Updating..."
                size="md"
                borderRadius="lg"
                px={6}
                bgGradient="linear(to-r, purple.500, pink.600)"
                _hover={{
                  bgGradient: 'linear(to-r, purple.600, pink.700)',
                  transform: 'translateY(-1px)',
                }}
                transition="all 0.2s"
                leftIcon={<FaUserEdit />}
              >
                Update User
              </Button>
            </HStack>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditUserModal;
